<template>
    <div v-if="enabled">
        <div class="filter-heading cf" >
            <p class="filter-title">
                {{ label }} <small v-if="selected.length">({{ selected.length }} applied)</small>
            </p>
        </div>
        <div class="filter-body">
            <div class="checkbox" v-for="item in filters" :key="item.key">
                <label>
                    <input type="checkbox" v-model="selected" :value="item.key" @change="bump">
                    <span class="faux-label">
                        <span v-html="item.key ? item.key : '-'"></span>
                        <span class="product-count">({{ item.count }})</span>
                    </span>
                </label>
            </div>
        </div>
        <div class="filter-footer">
            <button @click="expanded = false" v-if="expanded">Show less</button>
            <button @click="expanded = true" v-else-if="hiddenCount">Show {{ hiddenCount }} more </button>
        </div>

    </div>
</template>

<script>
    import { TextFilter } from '../../../../Services/Search/TextFilter.js';
    import UrlHelpers from '../../../../Services/UrlHelpers.js';
    import Search from '../../../../Services/Search.js';

    export default {
        props: {
            expand: {
                type: Boolean,
                default: true,
            },
            enable: {
                type: Boolean,
                default: false,
            },
            handle: {
                type: String,
            },
            items: {
                type: [Object,Array],
                default() {
                    return [];
                }
            }
        },
        data() {
            return {
                selected: [],
                expanded: false,
                search: Search,
            }
        },
        mounted() {
            let filters = UrlHelpers.getParam(this.handle);
            if (filters) {
                filters = filters.split(':');
                _.each(filters, filter => {
                    this.selected.push(filter);
                });
            }
            this.loaded();
        },
        methods: {
            bump() {
                this.$emit('bump', new TextFilter(this.handle, this.selected));
            },
            loaded() {
                this.$emit('loaded', new TextFilter(this.handle, this.selected));
            }
        },
        computed: {
            rows() {
                return this.brands.buckets;
            },
            hiddenCount() {
                return this.items.length - this.filters.length;
            },
            filters() {
                if (this.expanded) {
                    return this.items;
                }
                return _.take(Object.values(this.items), 5);
            },
            label() {
                return _.startCase(this.handle);
            },
            enabled() {
                return this.enable || (this.search.resolving ? true : this.search.aggregations[this.handle] != undefined);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Search/Filters/Loop54/Filter.vue